import Axios from "../../../api/axios/Axios";

const BASE_URL = "/api/notifications";

export const getNotifications = (limit = 20, offset = 0) =>
  Axios.get(BASE_URL, {
    params: { limit, offset },
  });

export const getUnreadCount = () => Axios.get(`${BASE_URL}/unread-count`);

export const markNotificationAsRead = (notificationId) =>
  Axios.put(`${BASE_URL}/${notificationId}/read`);

export const markAllNotificationsAsRead = () =>
  Axios.put(`${BASE_URL}/read-all`);

export const getChannelFollowStatus = (username) =>
  Axios.get(`${BASE_URL}/follows/${encodeURIComponent(username)}`);

export const followChannel = (username) =>
  Axios.post(`${BASE_URL}/follows/${encodeURIComponent(username)}`);

export const unfollowChannel = (username) =>
  Axios.delete(`${BASE_URL}/follows/${encodeURIComponent(username)}`);
